import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { Modal, ListGroup } from 'react-bootstrap';
import './index.css';
import FolderIcon from '@mui/icons-material/Folder';  
import FolderOpenIcon from '@mui/icons-material/FolderOpen';
import CircleIcon from '@mui/icons-material/Circle'; 
import EditIcon from '@mui/icons-material/Edit';  
import FormatIndentDecreaseIcon from '@mui/icons-material/FormatIndentDecrease';  

// NEW MUI
// import { Typography } from '@mui/material';
import Tree, { getTreeLeafDataByIndexArray } from 'material-ui-tree';
import APIService from '../../Services/APIService';

const PermissionModal = ({
  existingProfileIds,
  dataInfo,
  showPermissionModal,
  onClose,
  onSubmit,
  createPermission,
}) => {
  console.log('  createPermission', createPermission, '  createPermission');
  const [state, setState] = useState({
    data: {
      supplierName: 'All Campaign',
      type: 'campaign',
      entityId: 'all',
      data: [],
    },
    userProfileOptions: [],
    selectedProfile: {
      label: undefined,
      value: undefined,
    },
  });

  const getUserProfileList = async () => {
    let res = await APIService.get(`/v0/ui/accounts/profiles/`);
    if (res.status == 200) {
      let userProfileOptions = [];
      res.data &&
        res.data.forEach((userProfileData) => {
          if (existingProfileIds.indexOf(userProfileData.id) === -1) {
            userProfileOptions.push({
              label: userProfileData.name,
              value: userProfileData.id,
            });
          }
        });
      if (userProfileOptions.length === 0) {
        userProfileOptions.push({
          label: 'No more profiles',
          value: undefined,
        });
      }
      setState({
        ...state,
        userProfileOptions,
      });
    }
  };
  useEffect(() => {
    getUserProfileList();

    if (
      (!state.data.data.length && dataInfo.length) ||
      (state.data.data.length &&
        dataInfo.length &&
        state.data.data[0].entityId !== dataInfo[0].entityId)
    ) {
      let dataInfo = state.data;
      dataInfo.data = dataInfo;
      setState({
        ...state,
        data: dataInfo,
      });
    }
  }, []);

  const customStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      maxHeight: '550px',
      minWidth: '100px',
      width: '50%',
      transform: 'translate(-50%, -50%)',
      padding: '15px 10px 10px',
    },
  };

  const classes = {
    container: 'tree-modal',
    icon: 'tree-icon',
    leaf: 'TreeDemo-leaf-179',
  };

  const onSelectProfile = (value) => {
    if (value.value) {
      setState({
        ...state,
        selectedProfile: value,
      });
    }
  };

  const requestTreeLeafChildrenData = (leafData, chdIndex, doExpand) => {
    doExpand();
  };

  const renderTreeLeafLabel = (leafData, expand) => {
    const { supplierName, type } = leafData;
    if (type === 'campaign') {
      if (!expand) {
        return (
          <ListGroup.Item viriant="body1" className={classes.leaf}>
            <FolderIcon className={classes.icon} />
            {supplierName}
          </ListGroup.Item>
        );
      }
    }
    return (
      <ListGroup.Item viriant="body1" className={classes.leaf}>
        <FolderOpenIcon className={classes.icon} />
        {supplierName}
      </ListGroup.Item>
    );
  };

  const getTreeLeafActionsData = (leafData, chdIndex, expand) => {
    return [
      {
        icon: <CircleIcon className="tree-action" />,
        hint: 'None',
        className:
          'permission-icon' + (leafData.permission === 'None' ? ' permission-selected' : ''),
        onClick: () => {
          const data = { ...state.data };
          alert(typeof chdIndex);
          const leaf = getTreeLeafDataByIndexArray(data, chdIndex, 'data');
          leaf.permission = 'None';
          if (leaf.data && leaf.data.length) {
            leaf.data.forEach((leafData) => {
              leafData.permission = 'None';
              if (leafData.data && leafData.data.length) {
                leafData.data.forEach((childData) => {
                  childData.permission = 'None';
                });
              }
            });
          }
          setState({ ...state, data });
        },
      },
      {
        icon: <EditIcon className="tree-action" />,
        hint: 'Edit',
        className:
          'permission-icon' + (leafData.permission === 'Edit' ? ' permission-selected' : ''),
        onClick: () => {
          const data = { ...state.data };
          const leaf = getTreeLeafDataByIndexArray(data, chdIndex, 'data');
          leaf.permission = 'Edit';
          if (leaf.data && leaf.data.length) {
            leaf.data.forEach((leafData) => {
              leafData.permission = 'Edit';
              if (leafData.data && leafData.data.length) {
                leafData.data.forEach((childData) => {
                  childData.permission = 'Edit';
                });
              }
            });
          }
          setState({ ...state, data });
        },
      },
      {
        icon: <FormatIndentDecreaseIcon className="tree-action" />,
        hint: 'Fill',
        className:
          'permission-icon' + (leafData.permission === 'Fill' ? ' permission-selected' : ''),
        onClick: () => {
          const data = { ...state.data };
          const leaf = getTreeLeafDataByIndexArray(data, chdIndex, 'data');
          leaf.permission = 'Fill';
          if (leaf.data && leaf.data.length) {
            leaf.data.forEach((leafData) => {
              leafData.permission = 'Fill';
              if (leafData.data && leafData.data.length) {
                leafData.data.forEach((childData) => {
                  childData.permission = 'Fill';
                });
              }
            });
          }
          setState({ ...state, data });
        },
      },
    ];
  };

  return (
    <Modal show={showPermissionModal} ariaHideApp={false} size="lg">
      <Modal.Header>
        <h3>Profile Permission</h3>
      </Modal.Header>
      <Modal.Body>
        {createPermission ? (
          <div className="createform__form__inline">
            <div className="form-control">
              <label>*Select Profile</label>
              <br />
              <Select
                className="modal-select"
                options={state.userProfileOptions}
                value={state.selectedProfile}
                onChange={(e) => onSelectProfile(e)}
              />
            </div>
          </div>
        ) : (
          ''
        )}
        <Tree
          className={classes.container}
          data={state.data}
          labelName="supplierName"
          valueName="entityId"
          childrenName="data"
          renderLabel={renderTreeLeafLabel}
          getActionsData={getTreeLeafActionsData}
          childrenCountPerPage={100}
        />
      </Modal.Body>
      <Modal.Footer>
        <div className="modal-footer">
          <button type="button" className="btn btn--danger" onClick={onClose}>
            Close
          </button>{' '}
          <button type="button" className="btn btn--danger" onClick={() => onSubmit(state)}>
            Submit
          </button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default PermissionModal;
